import { useContext } from "react";
import { FormattedMessage } from "react-intl";
import { Box, Switch } from "src/components/material-ui";
import { LoopUpOneRedirectContext } from "src/utils/contexts/loopupOneRedirect.tsx";

const LoopUpOneToggle = () => {
  const { shouldRedirect, setShouldRedirect } = useContext(
    LoopUpOneRedirectContext
  );

  return (
    <Box mr={2}>
      <Switch
        checked={shouldRedirect}
        onChange={(event) => setShouldRedirect(event.target.checked)}
      />
      <FormattedMessage id="loopUpOneToggle" />
    </Box>
  );
};

export default LoopUpOneToggle;
